export class TokenUtils {
  getToken = () => {
    const tokenItem = localStorage.getItem('token');
    return tokenItem;
  };

  setToken = (res) => {
    localStorage.setItem('token', res.data.jwt);
  };

  clearToken = () => {
    localStorage.removeItem('token');
  };

  parseJwtAdmin = (token) => {
    if (token) return JSON.parse(atob(token.split('.')[0])).Admin;
    else return false;
  };
}

const tokenUtils = new TokenUtils();

export default tokenUtils;
